import { render, staticRenderFns } from "./post-call-actions-tab.vue?vue&type=template&id=ff97e024"
import script from "./post-call-actions-tab.vue?vue&type=script&lang=js"
export * from "./post-call-actions-tab.vue?vue&type=script&lang=js"
import style0 from "./post-call-actions-tab.vue?vue&type=style&index=0&id=ff97e024&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports